import type { HiringStage } from "../types/stages";

export type StageOwner = "manager" | "worker" | "candidate" | "signing" | "system";

export const STAGE_OWNER: Record<HiringStage, StageOwner> = {
  invited: "manager",
  filling: "candidate",
  review: "manager",
  decision: "manager",
  contract_pending: "signing",
  contract_signed: "system",
  job_app_pending: "signing",
  job_app_review: "manager",
  job_app_approved: "system",
  order_pending: "manager",
  order_uploaded: "manager",
  completed: "system",
};

export function getStageOwner(stage: HiringStage): StageOwner {
  return STAGE_OWNER[stage];
}

export function canManagerAct(stage: HiringStage): boolean {
  return STAGE_OWNER[stage] === "manager";
}

export function canWorkerAct(stage: HiringStage): boolean {
  return STAGE_OWNER[stage] === "worker";
}


